import { graphql, useStaticQuery } from "gatsby";
import { SEO } from "@greythr/shared-components";

const SEOWrapper = (props) => {
  const { site } = useStaticQuery(graphql`
    query SEO {
      site {
        buildTime(formatString: "YYYY-MM-DD")
        siteMetadata {
          siteUrl
          defaultTitle: title
          defaultDescription: description
          defaultBanner: banner
          headline
          siteLanguage
          ogLanguage
          author
          twitter
          facebook
        }
      }
    }
  `);

  return <SEO {...props} site={site} />;
};

export default SEOWrapper;

